module.exports = {
  all: ['code', 'name', 'displayName', 'email', 'createdAt', 'isTeacher', 'studiedCount', 'points', 'command'],
  verified: ['code', 'name', 'displayName', 'email', 'createdAt', 'verifiedDate', 'isTeacher', 'studiedCount', 'points', 'command'],
  pending: ['code', 'name', 'displayName', 'email', 'createdAt', 'requestedDate', 'isTeacher', 'studiedCount', 'points', 'command'],
  rejected: ['code', 'name', 'displayName', 'email', 'createdAt', 'isTeacher', 'studiedCount', 'points', 'command'],
  deleted: ['code', 'name', 'displayName', 'email', 'createdAt', 'isTeacher', 'studiedCount', 'points', 'command'],
};
